import type { TableColumnFormat } from '../../../TableEndpoint';

/**
 * Get "base field" in data row of a column
 *
 * All yet prepared column types (except frontend only) have `format.field`,
 * so this is just a simple prop accessor.
 * But we need to clearly mark spots in code where we need to access base field,
 * for example when reading intent result for coloring columns.
 *
 * We should keep it as a standard that `format.field` always refer to the base column.
 * Typing & comment of this function will help us track down that we are sticking to it
 * and decide how to improve the implementation if it turns out to be needed.
 *
 * @return when column has no base field, null is returned.
 */
export const getBaseColumnField = (
  format: TableColumnFormat<any>,
): string | null => (format.type === 'frontendOnly' ? null : format.field);
